<template>
  <div>
    <v-dialog v-model="dialog" :max-width="width ? width : '50%'" :persistent="persistent">
      <v-card>
        <v-card-title v-if="titleProp">
          {{ titleProp }}
        </v-card-title>

        <!--
          not use v-text to avoid ESlint warning
          also, not put a line break between the end of an HTML tag(>) and the top of the mustache({{)
        -->
        <v-card-text :style="textStyle">{{ textProp }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <KtznAdminButton
            v-if="!hideButton1"
            :isOutlined="true"
            :label="btnTextProp.text1"
            :themeColor="themeColor"
            data-ktznta="186"
            @onClick="$emit('buttonOneEvent')"
          />
          <KtznAdminButton
            v-if="!hideButton2"
            :label="btnTextProp.text2"
            :themeColor="themeColor"
            data-ktznta="187"
            @onClick="$emit('buttonTwoEvent')"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { computed, createComponent, onMounted, PropType, value, Wrapper } from "vue-function-api";
import KtznAdminButton from "./KtznAdminButton.vue";
import vClickOutside from "v-click-outside";

export default createComponent({
  name: "KtznAdminCommonDialog",
  components: {
    KtznAdminButton,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: [
    "dialogProp", // Maintain dialog state
    "titleProp", // Title of dialog
    "textProp", // Text contents of dialog
    "textStyle", // Text contents style
    "btnTextProp", // Button labels object
    "themeColor", // Provide theme color if any specific (future project?) OR do not provide will render default
    "hideButton", // If button needs to be hidden
    "width", // Dialog width
    "persistent", // Dialog persistent
  ] as any as PropType<{
    dialogProp: boolean;
    titleProp: string;
    textProp: string;
    textStyle: string;
    btnTextProp: { text1: string; text2: string };
    themeColor: string;
    hideButton: { btn1: boolean; btn2: boolean };
    width: string;
    persistent: boolean;
  }>,
  setup(props, context) {
    const { titleProp, textProp, textStyle, btnTextProp, themeColor, width, persistent } = props;
    const hideButton1: Wrapper<boolean> = value(false);
    const hideButton2: Wrapper<boolean> = value(false);

    //Computed Properties
    const dialog: Wrapper<boolean> = computed(
      () => props.dialogProp,
      (val) => context.emit("dialogState", val)
    );

    onMounted(() => {
      hideButton1.value = props.hideButton ? !!props.hideButton.btn1 : false;
      hideButton2.value = props.hideButton ? !!props.hideButton.btn2 : false;
    });

    return {
      width,
      dialog,
      textProp,
      textStyle,
      titleProp,
      themeColor,
      btnTextProp,
      hideButton1,
      hideButton2,
      persistent,
    };
  },
});
</script>
